var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"calendar-grid"}},[_c('month-view-grid',{attrs:{"row":_vm.facilityId,"current-date":_vm.date,"items":_vm.bookings}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }